import { replaceContent } from "../utils/html";
import MapMembers from "../blocks/MapMembers";

//gsap
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin)

export default class ArchiveAdherent {
    constructor(el) {
        //div container
        this.el = el;

        this.elms = {
            //filters
            filterTaxMap: this.el.querySelector('[data-hwc-filter-tax-map]'),
            filterTiles: this.el.querySelectorAll('[data-hwc-filter-tiles]'),
            filterTaxTiles: this.el.querySelector('[data-hwc-filter-tax-tiles]'),
            filterDepTiles: this.el.querySelector('[data-hwc-filter-dep-tiles ]'),
            //container tiles ref
            body: this.el.querySelector('.hwc-ArchiveAdherent-container'),
            //pagination
            pages: this.el.querySelectorAll("[data-archive-page]"),
        }

        this.init();
    }

    init() {

        if (this.elms.filterTiles) {
            this.elms.filterTiles.forEach((el) => {
                el.addEventListener("change", () => this.filterTiles())
            });
        }

        if (this.elms.filterTaxMap) {
            this.elms.filterTaxMap.addEventListener("change", () => this.filterMap())
        }

        if (this.elms.pages) {
            this.elms.pages.forEach((el) => {
                el.addEventListener("click", (e) => this.changePage(e));
            });
        }

    }

    changePage(e) {
        e.preventDefault();

        if (e.target.dataset.archivePage == "next") {
            this.setNextPage();
        } else if (e.target.dataset.archivePage == "prev") {
            this.setPrevPage();
        } else {
            this.setPage(e.target.dataset.archivePage);
        }

        this.ajaxProcessTiles();
    }

    filterTiles() {
        this.setFirstPage();
        this.ajaxProcessTiles();
    }

    filterMap() {
        this.ajaxProcessMap();
    }

    getConfigTiles() {

        this.config = {
            paged: this.el.querySelector('[data-current-page]') ? this.el.querySelector('[data-current-page]').dataset.currentPage : '',
            dep: this.elms.filterDepTiles.value,
            term: this.elms.filterTaxTiles.value,
            posts_per_page: 6,
        }
    }

    getConfigMap() {

        console.log(this.elms.filterTaxMap.value);
        console.log(this.elms.filterTaxMap);


        this.config = {
            term: this.elms.filterTaxMap.value,
            posts_per_page: -1,
        }
    }

    ajaxProcessTiles() {

        this.getConfigTiles();
        var that = this;
        jQuery.ajax({
            url: hwc_vars.ajax_url,
            type: "post",
            data: {
                action: "hwc_ajax_archive_adherent_tiles",
                config: this.config,
            },
            success: (response) => {

                this.timeout = setTimeout(() => {

                    if (!response) {
                        return false;
                    }

                    let data = JSON.parse(response);

                    if (data.html && that.elms.body) {

                        replaceContent(data.html, '[data-replacement-tiles]');

                        if (this.el.querySelectorAll('[data-archive-page]').length) {
                            this.el.querySelectorAll('[data-archive-page]').forEach((el) => {
                                el.addEventListener('click', (e) => this.changePage(e));
                            });
                        }

                        this.setLastPage(data.last_page);
                        this.setTotalPosts(data.total_posts);

                        if (data.new_url) {
                            window.history.pushState(this.config, '', data.new_url);
                        }

                        gsap.to(window, { duration: 0.6, scrollTo: { y: this.el.getBoundingClientRect().top + window.scrollY - 140 } });
                    }
                }, 500);
            },
        });
    }

    ajaxProcessMap() {

        this.getConfigMap();
        var that = this;
        jQuery.ajax({
            url: hwc_vars.ajax_url,
            type: "post",
            data: {
                action: "hwc_ajax_archive_adherent_map",
                config: this.config,
            },
            success: (response) => {

                this.timeout = setTimeout(() => {

                    if (!response) {
                        return false;
                    }

                    let data = JSON.parse(response);

                    if (data.html && that.elms.body) {

                        replaceContent(data.html, '[data-replacement-map]');

                        if (this.el.querySelectorAll('[data-archive-page]').length) {
                            this.el.querySelectorAll('[data-archive-page]').forEach((el) => {
                                el.addEventListener('click', (e) => this.changePage(e));
                            });
                        }

                        this.setLastPage(data.last_page);
                        this.setTotalPosts(data.total_posts);

                        if (data.new_url) {
                            window.history.pushState(this.config, '', data.new_url);
                        }

                        const mapMembers = document.querySelector('[data-hwc-map-Members]');
                        if (mapMembers) {
                            new MapMembers(mapMembers);
                        }

                    }
                }, 500);
            },
        });
    }

    getCurrentPage() {
        if (this.el.querySelector('[data-current-page]')) {
            return Number(this.el.querySelector('[data-current-page]').dataset.currentPage);
        }
    }

    getLastPage() {
        if (this.el.querySelector('[data-last-page]')) {
            return Number(this.el.querySelector('[data-last-page]').dataset.lastPage);
        }
    }

    getTotalPosts() {
        if (this.el.querySelector('[data-total-post]')) {
            return Number(this.el.querySelector('[data-total-post]').dataset.totalPost);
        }
    }

    isLastPage() {
        return this.getLastPage() == this.getCurrentPage();
    }

    setFirstPage() {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = 1;
        }
    }

    setTotalPosts(value) {
        if (this.el.querySelector('[data-total-post]')) {
            this.el.querySelector('[data-total-post]').dataset.totalPost = value;
        }
    }

    setLastPage(value) {
        if (this.el.querySelector('[data-last-page]')) {
            this.el.querySelector('[data-last-page]').dataset.lastPage = value;
        }
    }

    setPage(value) {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = value;
        }
    }

    setPrevPage() {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = this.getCurrentPage() - 1;
        }
    }

    setNextPage() {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = this.getCurrentPage() + 1;
        }
    }
}
